import { useState } from 'react'
import { HostProvider, InstanceHost, useHost, useView } from '@10000/react'
import { Dashboard, Tenant, Tenants } from './'
import { Shell, Background } from '../layout'
import { Account, Billing, Organisations, Subscription, Teams, Users } from '../admin/settingsType'
import { Box } from '../widgets'

export const SuperRouter = () => {
  const [region, setRegion] = useState(window.localStorage['super.region'] || 'AP')

  const updateRegion = region => {
    window.localStorage['super.region'] = region
    setRegion(region)
  }

  return (
    <HostProvider region={region} requireExplicitRegion>
      <SuperRouterImplementation region={region} onRegionChange={updateRegion} />
    </HostProvider>
  )
}

export const SuperRouterImplementation = ({ region, onRegionChange }) => {
  const params = new URLSearchParams(window.location.search)
  const [tenantId, setTenantId] = useState(params.get('tenantId'))
  const host = useHost()
  const { company } = useView('tenant')

  const updateTenant = newTenant => {
    setTenantId(newTenant)

    const url = new URL(window.location.href)
    if(newTenant) {
      url.searchParams.set('tenantId', newTenant)
    } else {
      url.searchParams.delete('tenantId')
    }
    window.history.replaceState({}, '', url)
  }

  return (
    <Box fullWidth fullHeight maxHeight="100dvh" maxWidth="100dvw">
      <Background>
        <Shell>
          {host && (tenantId
            ? <TenantDashboard
                onTenantChange={updateTenant}
                tenantId={tenantId}
                companyName={company?.name}
              />
            : <Dashboard
                options={[{ title: 'Tenants', icon: 'Company', component: Tenants, props: { region, onTenantChange: updateTenant, onRegionChange} }]}
              />
          )}
        </Shell>
      </Background>
    </Box>
  )
}

const TenantDashboard = ({ tenantId, onTenantChange, companyName }) => (
  <InstanceHost entities={{ tenant: { id: tenantId, aggregates: ['tenant'], topic: 'tenantInput' } }}>
    <Dashboard
      title={companyName}
      goBack={() => onTenantChange('')}
      options={[
        { title: 'Overview', icon: 'Settings', component: Tenant },
        { title: 'Account', icon: 'User', component: Account },
        { title: 'Subscription', icon: 'Rocket', component: Subscription },
        { title: 'Billing', icon: 'PaymentCard', component: Billing },
        { title: 'Organisations', icon: 'Company', component: Organisations },
        { title: 'Teams', icon: 'Network', component: Teams },
        { title: 'Users', icon: 'Team', component: Users }
      ]}
    />
  </InstanceHost>
)